import React, { createContext, useContext, useState, useCallback } from 'react';
import QuoteDialog from '@/components/QuoteDialog';

const QuoteContext = createContext(null);

export const useQuote = () => useContext(QuoteContext);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState(null);

  const openQuote = useCallback((p = null) => {
    setProduct(p);
    setOpen(true);
  }, []);

  const closeQuote = useCallback(() => setOpen(false), []);

  return (
    <QuoteContext.Provider value={{ openQuote, closeQuote }}>
      {children}
      <QuoteDialog open={open} onOpenChange={setOpen} product={product} />
    </QuoteContext.Provider>
  );
};
